import type { IChoiceGroupOption } from "@fluentui/react";
import { ChoiceGroup } from "@fluentui/react";
import React, { useEffect, useState, type FormEvent } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { DigitalInputStateData } from "../../../api";
import { DigitalInput } from "../../../api";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode, { digitalInputOptions } from "./action-config-node";
import { useTranslation } from "react-i18next";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type DigitalInputStateNode = Node<InterfaceToRecord<DigitalInputStateData & ExtraNodeData>>;

export default function DigitalInputState(props: NodeProps<DigitalInputStateNode>): JSX.Element {
    const { t } = useTranslation();
    const [selectedDigitalInput, setSelectedDigitalInput] = useState(
        props.data.digitalInput ?? DigitalInput.INPUT1,
    );

    const updateNode = useUpdateNodeData<DigitalInputStateNode>(props.id);

    // We have to set the data to prevent undefined values
    useEffect(() => {
        updateNode({ digitalInput: selectedDigitalInput });
    }, [selectedDigitalInput, updateNode]);

    function onChange(
        _e?: FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption,
    ): void {
        if (!option) {
            return;
        }
        setSelectedDigitalInput(option.key as DigitalInput);
    }

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <ChoiceGroup
                options={digitalInputOptions(t)}
                selectedKey={selectedDigitalInput}
                onChange={onChange}
            />
        </ActionConfigNode>
    );
}
